import classnames from 'classnames/bind'
import { PropsWithClassName } from '~/@types/generic'
import { GlobalGridPreset } from '~/@types/grid-preset'

import HeroCategorySimpleDescription from '~/components/Slices/HeroCategorySimpleDescription'
import { HeroMainText } from '~/components/Slices/HeroMain/HeroMainText'

import { useStyle } from '~/providers/StyleProvider'

import { CategoryPageData } from '~/data/category-page-data/serializer'

import css from './styles.module.scss'

const cx = classnames.bind(css)

type CategoryBottomPageProps = PropsWithClassName<{
  isHeroTitleOnly?: boolean
  categoryHero?: CategoryPageData['categoryHero']
}>

function CategoryBottomPage({
  className,
  categoryHero,
  isHeroTitleOnly = true,
}: CategoryBottomPageProps) {
  const grid = useStyle({ grid: GlobalGridPreset.BASE_GRID })

  return (
    <div className={cx(css.CategoryBottomPage, className, grid)}>
      {isHeroTitleOnly && categoryHero?.heroSimple && (
        <HeroCategorySimpleDescription
          className={css.heroCategorySimpleDescription}
          {...categoryHero?.heroSimple}
        />
      )}
      {!isHeroTitleOnly && categoryHero?.heroMain && (
        <HeroMainText
          className={css.heroMainText}
          {...categoryHero?.heroMain?.content?.text}
        />
      )}
    </div>
  )
}
export default CategoryBottomPage
